const DEFAULT_JWT_TTL_MINUTES = 30;

export const getAuthRefreshDeadline = (expiresInMinutes?: number) => {
  const ttlMinutes =
    typeof expiresInMinutes === 'number' && Number.isFinite(expiresInMinutes) && expiresInMinutes > 0
      ? expiresInMinutes
      : DEFAULT_JWT_TTL_MINUTES;

  return Date.now() + ttlMinutes * 60 * 1000;
};
